import { render, staticRenderFns } from "./CampaignWizardFooterButtons.vue?vue&type=template&id=2541f62e&"
import script from "./CampaignWizardFooterButtons.vue?vue&type=script&lang=js&"
export * from "./CampaignWizardFooterButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports